import { render, staticRenderFns } from "./giveaway_introduction.vue?vue&type=template&id=37d1ae8c&scoped=true"
import script from "./giveaway_introduction.vue?vue&type=script&lang=ts"
export * from "./giveaway_introduction.vue?vue&type=script&lang=ts"
import style0 from "./giveaway_introduction.vue?vue&type=style&index=0&id=37d1ae8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1ae8c",
  null
  
)

export default component.exports